import { FC } from 'react';
import { useCurrentUser } from '@hooks/users';
import { Loader } from '@new/common/ui/Loader/Loader';
import { SectionHeading } from '../SectionHeading';
import { EmailSettingsForm } from './EmailSettingsForm';

export const EmailSettingsSection: FC = () => {
  const { data: user, isLoading, isError } = useCurrentUser();

  if (isLoading) return <Loader />;
  if (isError || !user) return <div>Failed to load user data.</div>;

  return (
    <div className="flex flex-col gap-6">
      <SectionHeading>Email Settings</SectionHeading>
      <EmailSettingsForm user={user} />
    </div>
  );
};
